<template>
  <div class="main-chat-wrapper">
    <div v-show="showDropFile" class="chat-drop-container" @drop="drop" @dragover="allowDrop" @dragleave="dragleave" @dragenter="allowDrop">
      {{ 'Drop file here' | i18n }}
    </div>
    <div class="chat-content-wrapper" @drop="drop" @dragover="allowDrop" @dragleave="dragleave" @dragenter="allowDrop">
      <div class="fixed-header">
        <div class="header-text-wrapp">
          <BlockHeader name="Chat" />
        </div>
        <div class="header-button-wrapp">
          <span v-if="colomns.chat === 12">
            <b-button size="sm" variant="outline-primary" @click="() => triggerWindow('video', 12)">{{ 'Close' | i18n }}</b-button>
          </span>
        </div>
      </div>
      <div class="home-page__content messages-page">
        <div class="container-fluid h-100">
          <div class="row px-0 h-100">
            <div class="chat col-12 px-0 pl-md-1">
              <div class="chat__container">
                <div class="chat__wrapper pt-mb-2 pb-md-3">
                  <div class="chat-header">
                    <div>
                      <Checkbox v-model="translateChat" placeholder="Translate chat" :left="0" :bottom="5" />
                    </div>
                    <div v-if="translateChat">
                      <Select
                        v-model="selectedLanguage"
                        :options="languagesOptions"
                        form-group-id="Language"
                        placeholder="Language"
                        input-placeholder="Select language"
                      />
                    </div>
                  </div>
                  <div class="chat__content px-3">
                    <div v-if="loading" class="chat__no-messages">
                      <Spinner />
                    </div>
                    <div v-if="!messages.length && !loading" class="chat__no-messages">
                      {{ 'No messages yet' | i18n }}
                    </div>
                    <ul v-show="!loading" class="chat__list-messages">
                      <div v-if="isMore" class="small-loading">
                        <Spinner />
                      </div>
                      <li v-for="(message, index) in messages" :key="message.key">
                        <div
                          v-if="
                            index !== 0 &&
                            messages[index - 1] &&
                            moment.utc(message.date).local().format('DD') !==
                              moment
                                .utc(messages[index - 1].date)
                                .local()
                                .format('DD')
                          "
                          class="chat__time"
                        >
                          {{ moment.utc(message.date).local().format('DD MMMM') }}
                        </div>
                        <div v-if="index === 0" class="chat__time">
                          {{ moment.utc(message.date).local().format('DD MMMM') }}
                        </div>
                        <div v-if="message.userId !== auth.id" class="chat__message-owner">
                          {{ message.userName }}
                        </div>
                        <div :class="`chat__bubble chat__bubble--${message.userId === auth.id ? 'me' : 'you'}`">
                          <!-- Message content -->
                          <div v-if="message.messageType === 'text'">
                            {{ message.message }}
                            <div v-if="message.userId !== auth.id && selectedLanguage && translateChat" class="translated-text">
                              {{
                                message.translation && message.translation[selectedLanguage]
                                  ? message.translation[selectedLanguage]
                                  : `${$translate('Translating')}...`
                              }}
                            </div>
                          </div>
                          <div v-if="message.messageType === 'file'" class="chat-file-wrapper">
                            <div v-if="message.isUploading" class="chat-image-overlay">
                              <div class="chat-image-progress-bar">
                                <div class="chat-image-progress-bar-line" :style="`width:${message.progress}%`" />
                              </div>
                            </div>
                            <div
                              v-if="message.contentType.includes('image')"
                              class="chat-image-wrapper"
                              :style="`${!message.fileURL || !message.onLoaded ? 'width:200px;' : ''}`"
                            >
                              <img
                                v-show="message.fileURL && message.onLoaded"
                                :src="message.fileURL ? message.fileURL : getFileURL(message)"
                                class="chat-image"
                                @load="onLoadedImage(message)"
                                @click="downloadFile(message)"
                              />
                              <Spinner v-if="!message.fileURL || !message.onLoaded" />
                            </div>
                            <div
                              v-else-if="message.contentType.includes('video')"
                              class="chat-image-wrapper"
                              :style="`${!message.fileURL || !message.onLoaded ? 'width:200px;' : ''}`"
                            >
                              <video
                                v-show="message.fileURL && message.onLoaded"
                                :src="message.fileURL ? message.fileURL : getFileURL(message, true)"
                                class="chat-image"
                                controls
                              />
                              <Spinner v-if="!message.fileURL || !message.onLoaded" />
                            </div>
                            <div v-else class="chat-image-wrapper chat-file-box" @click="downloadFile(message)">
                              <div class="file-icon" />
                              <span class="file-name">{{
                                `${
                                  message.message.length > 15
                                    ? `${message.message.slice(0, 7)}...${message.message.slice(message.message.length - 12, message.message.length)}`
                                    : message.message
                                }`
                              }}</span>
                            </div>
                          </div>
                          <!--  -->
                          <div :class="`chat__hours chat__hours--${message.userId === auth.id ? 'me' : 'you'}`">
                            {{ moment.utc(message.date).local().format('HH:mm') }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat__send-container" :style="`top:${mainSize.height - 60}px`">
        <div class="custom-form__send-wrapper">
          <form @submit.prevent="postMessage">
            <input id="message" v-model="text" type="text" class="form-control custom-form" placeholder="Message" autocomplete="off" />
          </form>
          <div class="custom-form__send-img" @click="uploadFile">
            <img style="width: 20px" :src="FileIcon" />
          </div>
          <div id="voice-record" :class="`record-voice ${isVoiceRecording ? 'record-voice-stop' : ''}`">
            <img :src="MicrophoneIcon" />
          </div>
          <div class="language-switch-box" v-show="isVoiceRecording">
            <select class="language-select" id="language-select">
              <option v-for="l in SPEECH_LANGUAGE" :key="l.key" :value="l.value" :selected="l.value === selectedRecordLanguage">{{ l.key }}</option>
            </select>
          </div>
          <button type="submit" class="custom-form__send-submit" @click="postMessage">
            <img style="width: 23px" :src="MessageIcon" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '../../../../../api/index';

import { ProjectsMixin, NotificationMixin, FirebaseMixinOne, AuthMixin } from '../../../../../../mixins';
import BlockHeader from '../../../../common/block-header';
import { SPEECH_LANGUAGE } from '../../../../../../../../../constants';
import Spinner from '../../../../common/spinner';
import Select from '../../../../common/select';
import Checkbox from '../../../../common/checkbox';
import MicrophoneIcon from '../../../../../../assets/icons/microphoneWhite.svg';
import FileIcon from '../../../../../../assets/icons/file.svg';
import MessageIcon from '../../../../../../assets/icons/message.svg';

let final_transcript;

export default {
  name: 'Chat',
  components: { Spinner, Select, Checkbox, BlockHeader },
  mixins: [ProjectsMixin, NotificationMixin, FirebaseMixinOne, AuthMixin],
  props: {
    hash: {
      type: String,
      default: () => '',
    },
    languages: {
      type: Array,
      default: () => [],
    },
    triggerWindow: {
      type: Function,
      default: () => {},
    },
    addMessageCount: {
      type: Function,
      default: () => {},
    },
    colomns: {
      type: Object,
      default: () => {},
    },
    mainSize: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      FileIcon: FileIcon,
      MessageIcon: MessageIcon,
      MicrophoneIcon: MicrophoneIcon,
      moment: moment,
      messages: [],
      selectedLanguage: null,
      SPEECH_LANGUAGE: Object.keys(SPEECH_LANGUAGE).map((key) => ({ key: key, value: SPEECH_LANGUAGE[key] })),
      selectedRecordLanguage: 'de',
      text: '',
      lastKey: '',
      limit: 20,
      isMore: false,
      loading: true,
      updating: false,
      translateChat: false,
      removeFunction: () => {},
      isVoiceRecording: false,
      dropIntervalId: {},
      showDropFile: false,
      timeOffset: 0,
    };
  },
  computed: {
    languagesOptions: function () {
      return this.languages.map((l) => ({ value: l.value, text: l.name }));
    },
  },
  watch: {
    async translateChat(newValue) {
      if (this.selectedLanguage && newValue) {
        this.translate(this.selectedLanguage);
      }
    },
    async selectedLanguage(newValue) {
      this.translate(newValue);
    },
    async messages() {
      this.translate();
    },
  },
  beforeDestroy() {
    this.removeFunction();
  },
  async mounted() {
    try {
      const time = await api.time.get();

      this.timeOffset = time.time - moment.utc().valueOf();

      const cbNewMessage = (m) => {
        this.removeFunction = m.removeFunction;
        if (m.data.messageType === 'file') {
          const exist = this.messages.some((i) => i.message === m.data.message);
          if (exist) {
            return;
          }
        }
        console.log('New message received:', m);
        this.messages.push(m.data);
        this.addMessageCount();
        setTimeout(() => {
          var container = this.$el.querySelector('.chat__content');
          container.scrollTop = container.scrollHeight;
        }, 1);
      };
      console.log('Init firebase');
      await this.firebaseServiceOne.initFirebase();

      await this.loadMessages();
      this.firebaseServiceOne.subscribeOnMessage(this.hash, cbNewMessage, this.timeOffset);

      this.$el.querySelector('.chat__content').addEventListener('scroll', this.handleScroll);

      if ('webkitSpeechRecognition' in window) {
        let needStartAgain = false;

        let speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = true;
        speechRecognition.interimResults = true;
        speechRecognition.lang = 'de';

        speechRecognition.onstart = () => {
          console.log('onstart');
        };
        speechRecognition.onend = () => {
          console.log('onend');
          if (needStartAgain) {
            start();
          } else {
            this.isVoiceRecording = false;
          }
          needStartAgain = false;
        };
        speechRecognition.onError = () => {
          console.log('onError');
        };

        final_transcript = '';

        speechRecognition.onresult = (event) => {
          let interim_transcript = '';

          for (let i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              final_transcript += event.results[i][0].transcript;
            } else {
              interim_transcript += event.results[i][0].transcript;
            }
          }

          this.text = final_transcript;
          setTimeout(() => {
            const m = document.querySelector('#message');
            m.focus();
            m.scrollLeft = m.scrollWidth;
          }, 10);
        };

        const start = () => {
          final_transcript = this.text;
          speechRecognition.start();
          document.querySelector('#message').focus();
          this.isVoiceRecording = true;
        };

        const stop = () => {
          final_transcript = '';
          speechRecognition.stop();
          this.isVoiceRecording = false;
        };

        document.querySelector('#voice-record').onclick = () => {
          if (this.isVoiceRecording) {
            stop();
          } else {
            start();
          }
        };

        const changeLanguage = (lang) => {
          speechRecognition.lang = lang;
          this.selectedRecordLanguage = lang;
          needStartAgain = true;
          final_transcript = ' ';
          speechRecognition.stop();
        };

        document.querySelector('#language-select').onchange = (e) => {
          changeLanguage(e.target.value);
        };
        // document.querySelector('#change-language-de').onclick = () => {
        //   changeLanguage('de-DE', 'DE');
        // };
      } else {
        console.log('Speech Recognition Not Available');
      }
    } catch (err) {
      this.showNotification({ type: 'error', message: err.message });
    }
  },
  destroyed() {
    this.$el.querySelector('.chat__content').removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    hideDrop(e) {
      if (this.dropIntervalId.id) {
        clearTimeout(this.dropIntervalId.id);
      }
      this.dropIntervalId.id = setTimeout(() => {
        this.showDropFile = false;
      }, 10);
    },
    drop(event) {
      event.preventDefault();
      this.hideDrop(event);
      const file = event.dataTransfer.files[0];
      if (!file) {
        return;
      }
      const uniqID = Math.random().toString(16).slice(2);
      const message = this.addUploadingMessage({ file, uniqID });
      const ref = this.messages.find((i) => i.key === uniqID);
      if (!file.type.includes('image')) {
        ref.onLoaded = true;
      }
      this.firebaseServiceOne.uploadFile({ hash: this.hash, file, uniqID, ref, message });
    },
    allowDrop(event) {
      event.preventDefault();
      if (this.dropIntervalId.id) {
        clearTimeout(this.dropIntervalId.id);
      }
      this.showDropFile = true;
    },
    dragleave(event) {
      event.preventDefault();
      this.hideDrop(event);
    },

    async translate(newValue) {
      const lng = newValue ? newValue : this.selectedLanguage;
      if (lng && this.translateChat) {
        for (const index in this.messages) {
          const msg = this.messages[index];
          if (msg.userId !== this.auth.id && msg.messageType === 'text') {
            const translated = await this.projectsService.translateMessage({ message: msg.message, language: lng });
            if (!msg.translation) {
              this.$set(msg, 'translation', {});
            }
            this.$set(msg.translation, lng, translated.data);
          }
        }
      }
    },
    async downloadFile(message) {
      const link = await this.getFileURL(message);
      window.open(link, '_blank');
    },
    async getFileURL(message, manageLoaded = false) {
      const url = await this.firebaseServiceOne.getFileURL({ hash: this.hash, fileName: message.message });
      this.messages.forEach((i) => {
        if (i.key === message.key) {
          i.fileURL = url;
          if (manageLoaded) {
            i.onLoaded = true;
          }
        }
      });
      return url;
    },
    async onLoadedImage(message) {
      this.messages.forEach((i) => {
        if (i.key === message.key) {
          i.onLoaded = true;
        }
      });
    },
    addUploadingMessage({ file, uniqID }) {
      const data = {
        isUploading: true,
        progress: 0,
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        key: uniqID,
        message: `${uniqID}-${file.name}`,
        messageType: 'file',
        contentType: file.type,
        userId: this.auth.id,
        userName: this.auth.email,
        fileURL: URL.createObjectURL(file),
        onLoaded: false,
      };
      this.messages.push(data);
      setTimeout(() => {
        var container = this.$el.querySelector('.chat__content');
        container.scrollTop = container.scrollHeight;
      }, 1);
      return data;
    },
    uploadFile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const uniqID = Math.random().toString(16).slice(2);
          const message = this.addUploadingMessage({ file, uniqID });
          const ref = this.messages.find((i) => i.key === uniqID);
          if (!file.type.includes('image')) {
            ref.onLoaded = true;
          }
          this.firebaseServiceOne.uploadFile({ hash: this.hash, file, uniqID, ref, message });
        }
      };
      input.click();
    },
    handleScroll() {
      const top = this.$el.querySelector('.chat__content').scrollTop;

      if (top < 100 && !this.updating && this.isMore) {
        this.updating = true;
        setTimeout(this.loadMessages, 1200);
      }
    },
    async loadMessages() {
      const cbAllMessages = (m) => {
        const temp = this.$el.querySelector('.chat__list-messages').clientHeight;

        if (!m) {
          this.isMore = false;
          this.loading = false;
          this.updating = false;
          return;
        }
        const messages = [];
        Object.keys(m).forEach((key) => {
          const i = {
            ...m[key],
            key,
            date: moment.utc(m[key].date).format('YYYY-MM-DD HH:mm:ss'),
            fileURL: null,
            onLoaded: false,
          };
          messages.push(i);
        });

        this.messages = [...messages, ...this.messages];
        if (this.messages && this.messages[0]) {
          this.lastKey = this.messages[0].key;
        }
        this.loading = false;
        this.updating = false;
        if (this.messages.length === this.limit) {
          this.isMore = true;
        }

        setTimeout(() => {
          const newHeight = this.$el.querySelector('.chat__list-messages').clientHeight;
          this.$el.querySelector('.chat__content').scrollTop = newHeight - temp;
          setTimeout(() => {
            this.updating = false;
          }, 10);
        }, 1);
      };

      this.firebaseServiceOne.getAllMessages({ hash: this.hash, lastKey: this.lastKey, cb: cbAllMessages, limit: this.limit });
    },
    async postMessage() {
      if (!this.text) {
        return;
      }
      const message = {
        messageType: 'text',
        message: this.text,
        date: moment.utc().valueOf() + this.timeOffset,
        userId: this.auth.id,
        userName: this.auth.email,
      };

      this.text = '';
      final_transcript = '';
      this.firebaseServiceOne.postMessage(this.hash, message);
    },
  },
};
</script>

<style lang="scss">
/* ===================================
    Variables
====================================== */

.chat-drop-area {
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}

.chat-drop-container {
  position: absolute;
  z-index: 10000000000;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 35px;
  border-radius: 0.2rem;
}

:root {
  --bg-page: #ffffff;
  --bg-page-darker: #f7f7f7;
  --bg-page-darkest: #b3b3b3;
  --colour-primary: #3996fb;
  --colour-primary-lightest: #e8f3ff;
  --colour-primary-darker: #1a7ee6;
  --colour-third: #419d78;
  --colour-third-lighter: #7bc9aa;
  --colour-third-lightest: #e6f7f0;
  --colour-text: #696969;
  --colour-text-lighter: #9b9b9b;
  --colour-text-darker: #626262;
  --colour-text-darkest: #363636;
  --border-color: #e8e7e7;
  --form-radius: 13px;

  --search-form-bg-colour: #f2f2f2;
  --send-form-bg-colour: #f2f2f2;
  --send-btn-box-shadow-colour: #7bbafd;
  --chat-bubble-me: #f2f2f2;
  --chat-bubble-you: var(--colour-primary);
}

.dark-mode {
  --bg-page: #1a1a1a;
  --bg-page-darker: #363636;
  --bg-page-darkest: #818181;
  --colour-primary: #1a71d0;
  --colour-primary-lightest: #202c3a;
  --colour-primary-darker: #449ffd;
  --colour-third: #41c590;
  --colour-third-lighter: #56d6a3;
  --colour-third-lightest: #272f2c;
  --colour-text: #c7c7c7;
  --colour-text-lighter: #868686;
  --colour-text-darker: #dcdcdc;
  --colour-text-darkest: #eaeaea;
  --border-color: #4c4c4c;

  --search-form-bg-colour: #363636;
  --send-form-bg-colour: #363636;
  --send-btn-box-shadow-colour: #44515f;
  --chat-bubble-me: #363636;
  --chat-bubble-you: var(--colour-primary);
}

$navbar-z-index: 10000;

//  BREAKPOINTS
$breakpoints: (
  ultra-large: 1440px,
  extra-large: 1366px,
  large: 1199px,
  // lg
  medium: 991px,
  // md
  small: 767px,
  // sm
  extra-small: 575px,
  // xs
  mobile: 480px,
  tiny: 320px,
);

/* ===================================
    Base
====================================== */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.small-loading {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

/* ===================================
    Mixins & functions
====================================== */

.fixed-header {
  top: 0;
  left: 0;
  background: white;
  padding: 15px;
  position: absolute;
  width: 100%;
  z-index: 10;
  border-bottom: 1px solid #d9d9d9;
}

.fixed-header .block-header {
  margin: 0 !important;
}

.header-button-wrapp {
  position: absolute;
  top: 0;
  right: 10px;
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
}

.record-voice {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--colour-primary);
  position: absolute;
  z-index: 100000;
  top: 22%;
  left: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  img {
    width: 15px;
  }
}

.record-voice-stop {
  background: rgb(219, 71, 79);
}

.language-switch-box {
  background: #f2f2f2;
  border-radius: 13px;
  position: absolute;
  display: flex;
  top: -82%;
  left: 0px;
  padding: 5px;
}

.language-select {
  border: none;
  background: transparent;
}

@mixin media($breakpoint) {
  @media screen and (max-width: map-get($map: $breakpoints, $key: $breakpoint)) {
    @content;
  }
}
@mixin media-min-width($breakpoint) {
  @media screen and (min-width: map-get($map: $breakpoints, $key: $breakpoint) + 1) {
    @content;
  }
}

@mixin user-profile-name-rfs {
  font-size: 1.15rem;

  @include media(small) {
    font-size: 1.1rem;
  }
}

@mixin title-rfs {
  font-size: 1.5rem;

  @include media(large) {
    font-size: 1.5rem;
  }
}
@mixin p-rfs {
  font-size: 1rem;

  @include media(large) {
    font-size: 0.9rem;
  }
}
@mixin small-text-rfs {
  font-size: 0.9rem;
}
@mixin very-small-text-rfs {
  font-size: 0.8rem;
}

/* ===================================
    Main
====================================== */

.chat-content-wrapper {
  position: absolute;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.main-chat-wrapper {
  position: relative;
  height: 100%;
  border-left: 1px solid var(--border-color);
}
.messages-page {
  height: 100%;
  max-height: calc(100vh - 49px);
  overflow-y: scroll;
  overflow-x: hidden;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    color: var(--colour-text-darker);
    font-weight: bold;
    @include title-rfs;
  }
  &__dark-mode-toogler {
    width: 2.6rem;
    height: 2.6rem;
    padding: 0.35rem;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: var(--colour-primary);
      border-color: var(--colour-primary);

      & path {
        fill: var(--bg-page-darker);
      }
    }
  }
  &__list {
    list-style: none;
    flex-grow: 1;
    overflow-y: auto;
  }
  &__list-scroll {
    height: 100%;
    overflow: hidden;
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.custom-form {
  color: var(--colour-text-darkest);
  padding: 1.5rem;
  border-radius: 13px;
  // display: flex;
  // justify-content: center;

  &__search-wrapper,
  &__send-wrapper {
    width: 90%;
    height: 100%;
    position: relative;

    & input {
      &::placeholder {
        color: var(--colour-text-lighter);
        @include small-text-rfs;
      }
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }
  &__search-wrapper {
    & input {
      padding-right: 3rem;
      background-color: var(--search-form-bg-colour);
      border: 1px solid var(--bg-page);

      &:placeholder-shown {
        background-color: var(--search-form-bg-colour);
        border: 1px solid var(--bg-page);
      }
      &:focus {
        background-color: var(--bg-page);
        border-color: var(--border-color);
        color: var(--colour-text);
      }
    }
  }
  &__send-wrapper {
    & input {
      padding-right: 6rem;
      padding-left: 77px;
      background-color: var(--send-form-bg-colour);
      border: none;

      &:focus {
        background-color: var(--send-form-bg-colour);
        border-color: transparent;
        color: var(--colour-text);
      }
    }
  }
  &__search-submit {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 3.5rem;
    cursor: pointer;

    background-color: transparent;
    border: none;
    outline: none;

    display: flex;
    justify-content: center;
    align-items: center;

    &:focus {
      outline: none;
      border: none;
    }
  }
  &__send-submit {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    height: 2.3rem;
    width: 2.3rem;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: var(--colour-primary);
    border-radius: 50%;
    box-shadow: 0 3px 3px var(--send-btn-box-shadow-colour);
    border: none;
    outline: none;

    text-align: center;
    font-size: 1.2rem;
    padding-top: 0.3rem;
    color: white;
    padding-right: 0.1rem;

    &:focus {
      outline: none;
      border: none;
    }
    &:hover {
      background-color: var(--colour-primary-darker);
    }
  }
  &__send-img {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    width: 2.3rem;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__send-emoji {
    position: absolute;
    top: 50%;
    right: 3.2rem;
    transform: translateY(-50%);
    width: 2.3rem;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.messaging-member {
  $self: &;
  border-radius: var(--form-radius);

  &:hover {
    background-color: var(--bg-page-darker);
  }

  &--new {
    & #{$self}__name {
      color: var(--colour-text-darker);
    }
    & #{$self}__message {
      color: var(--colour-text-darker);
      font-weight: bold;
    }
  }
  &--online {
    & .user-status {
      background-color: var(--colour-third-lighter);
    }
  }

  &--active {
    background-color: var(--colour-primary-lightest);

    &:hover {
      background-color: var(--colour-primary-lightest);
    }

    @include media(small) {
      background-color: var(--bg-page);

      &:hover {
        background-color: var(--bg-page-darker);
      }
    }
  }

  &__wrapper {
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: var(--form-radius);

    display: grid;
    grid-template-columns: 4rem 4fr;
    grid-template-rows: 2rem 2rem;
    column-gap: 1rem;
    grid-template-areas:
      'avatar     name'
      'avatar     message';

    @include media(large) {
      grid-template-columns: 3.5rem 1fr;
      grid-template-rows: 1.75rem 1.75rem;
    }
    @include media(medium) {
      grid-template-columns: 3.2rem 1fr;
      grid-template-rows: 1.75rem 1.75rem;
    }
  }
  &__avatar {
    grid-area: avatar;
    position: relative;

    & img {
      border-radius: 50%;
      width: 100%;
    }
  }

  &__name {
    font-weight: bold;
    grid-area: name;
    color: var(--colour-text-darker);
    margin-top: auto;

    @include small-text-rfs;
  }
  &__message {
    grid-area: message;
    white-space: nowrap;
    word-break: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    @include small-text-rfs;
  }
}

.chat-file-wrapper {
  position: relative;
}
.chat-image-wrapper {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease-in-out;
}
.chat-image {
  height: 200px;
  border-radius: 13px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer;
}
.chat-image-overlay {
  width: 100%;
  height: 100%;
  border-radius: 13px;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}
.chat-image-progress-bar {
  width: 100%;
  background: #808080;
  border-radius: 35px;
  height: 4px;
}
.chat-image-progress-bar-line {
  width: 0%;
  height: 4px;
  border-radius: 35px;
  background: white;
  transition: all 0.5s ease-in-out;
}

.file-icon {
  color: #2260ff;
  width: 45px;
  height: 35px;
  background: url('../../../../../../assets/icons/blue/case_template_blue.svg');
  background-repeat: no-repeat;
  background-size: 35px;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  width: 185px;
}

.chat-file-box {
  padding-top: 10px;
  width: 250px;
  height: 45px;
  cursor: pointer;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
}

.chat {
  $self: &;
  height: 100%;
  width: 100%;

  &__container {
    height: 100%;
    width: 100%;
  }
  &__wrapper {
    padding-top: 65px;
    background-color: var(--bg-page);
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include media(small) {
      border-left: none;
      border-right: none;
    }
  }
  &__messaging {
    width: 100%;
    border-bottom: 1px solid var(--border-color);

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__previous {
    width: 8%;
    min-width: 2rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    cursor: pointer;
    color: var(--colour-primary);
  }
  &__notification {
    width: 4%;
    min-width: 1.5rem;

    & span {
      display: none;
      width: 1.4rem;
      height: 1.4rem;
      text-align: center;
      border-radius: 50%;
      font-weight: bold;
      color: white;
      background-color: var(--colour-primary);
      @include small-text-rfs;
    }

    &--new {
      & span {
        display: block;
      }
    }
  }
  &__infos {
    flex-grow: 1;
  }
  &__actions {
    font-size: 5px;
    height: 2rem;
    min-width: 2rem;
    color: var(--colour-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & ul {
      list-style: none;
      display: flex;
    }
    & li {
      width: 2.6rem;
      height: 2.6rem;
      padding: 0.35rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: var(--bg-page);

      & + li {
        margin-left: 0.3rem;
      }
      &:hover {
        background-color: var(--colour-primary-lightest);
      }
    }
  }
  &__content {
    flex-grow: 1;
    overflow-y: auto;
  }
  &__content::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }

  &__no-messages {
    height: 85%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  &__list-messages {
    list-style: none;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    & li {
      margin-bottom: 0.7rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      & #{$self}__bubble {
        margin-bottom: 0.2rem;
      }
    }
  }
  &__bubble {
    position: relative;
    color: var(--colour-text-darkest);
    padding: 0.5rem 1rem;
    border-radius: 22px;
    background-color: var(--bg-page);
    max-width: 30rem;

    @include small-text-rfs;

    overflow: hidden;
    overflow-wrap: break-word;
    word-break: break-word;

    &--you {
      margin-right: 2rem;
      color: white;
      background-color: var(--chat-bubble-you);
    }
    &--me {
      margin-left: 2rem;
      background-color: var(--chat-bubble-me);
      align-self: flex-end;
    }
  }
  &__time {
    @include very-small-text-rfs;
    color: var(--colour-text-lighter);
    align-self: center;
    padding-bottom: 0.2rem;
  }
  &__hours {
    padding-top: 10px;
    @include very-small-text-rfs;
    align-self: center;
    text-align: right;
    font-size: 10px;
    &--you {
      color: white;
    }
    &--me {
      color: var(--colour-text-lighter);
    }
  }
  &__message-owner {
    @include very-small-text-rfs;
    color: var(--colour-text-lighter);
    align-self: center;
    text-align: left;
    font-size: 10px;
    width: 100%;
  }
  &__send-container {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    background: white;
  }
  &-member {
    &__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    &__avatar {
      position: relative;
      width: 3.5rem;

      & img {
        border-radius: 50%;
        width: 100%;
      }

      @include media(small) {
        width: 2.5rem;
      }
    }
    &__name {
      font-weight: bold;
      color: var(--colour-text-darker);
      margin-top: auto;
      white-space: nowrap;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      @include p-rfs;
    }
    &__details {
      margin-left: 0.8rem;
      display: flex;
      justify-content: center;
      flex-direction: column;

      @include media(small) {
        margin-left: 1rem;
      }
    }
    &__age {
      @include small-text-rfs;
      color: var(--colour-text-lighter);
      position: relative;

      &::after {
        content: ' . ';
        font-size: 0px;
        position: absolute;
        top: 50%;
        right: -4px;
        width: 3px;
        height: 3px;
        background-color: var(--colour-text-lighter);
        border-radius: 50%;
      }
    }
    &__status {
      color: var(--colour-text-lighter);
      @include very-small-text-rfs;
    }
  }
  &__profile {
    width: 100%;
    height: 100%;
    max-width: 20rem;
  }

  &--mobile {
    position: fixed;
    top: 0;
    left: 0;
    z-index: $navbar-z-index + 1;
    transform: translateY(100%);
    display: none;
    transition: transform 0.3s ease-in-out 0.1s;

    & #{$self}__wrapper {
      border-radius: 0;
    }
    &#{$self}--show {
      display: block;
      transform: translateY(0%);
      border-radius: 0;
    }
  }
}

.user-profile {
  $self: &;
  width: 100%;
  height: 100%;
  position: relative;

  &__wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    // max-width: 20rem;
    padding-top: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  &__close {
    position: absolute;
    top: 1rem;
    left: 1.5rem;
    width: 2rem;
    height: 2rem;
    color: var(--colour-primary);
    font-size: 1.375rem;

    cursor: pointer;
    z-index: $navbar-z-index + 3;
  }
  &__avatar {
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
      width: 9rem;
      border-radius: 50%;
    }
  }
  &__name {
    font-weight: bold;
    margin-top: 0.7rem;
    color: var(--colour-text-darker);
    word-wrap: break-word;

    @include user-profile-name-rfs;
  }
  &__phone {
    color: var(--colour-text-darker);
    @include small-text-rfs;
  }
  &__details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  &__location {
    color: var(--colour-text-lighter);
    @include small-text-rfs;
  }
  &__description {
    text-align: center;

    & p {
      margin-top: 1.3rem;
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;

      @include small-text-rfs;
    }
  }
  &__label {
    @include small-text-rfs;
    font-weight: bold;
  }
  &__tags {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    & li {
      padding: 0.3rem 1rem;
      border-radius: 1rem;
      margin-right: 0.3rem;
      margin-bottom: 0.3rem;
      @include small-text-rfs;
    }
    & a {
      &:hover {
        text-decoration: none;
      }
    }

    &--primary {
      & li {
        background-color: var(--colour-primary-lightest);
        color: var(--colour-primary-darker);
      }
      & a {
        &:hover {
          color: var(--colour-primary-darker);
        }
      }
    }
    &--secondary {
      & li {
        background-color: var(--colour-third-lightest);
        color: var(--colour-third);
      }
      & a {
        &:hover {
          color: var(--colour-third);
        }
      }
    }
  }

  &--large {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    z-index: $navbar-z-index + 2;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out 0.1s;
    background-color: var(--bg-page);
    box-shadow: -3px 0 3px rgba($color: #000000, $alpha: 0.06);

    &#{$self}--show {
      display: block;
      transform: translateX(0%);
      border-radius: 0;
    }
  }
}

.user-status {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 1rem;
  height: 1rem;
  background-color: var(--colour-text-lighter);
  border: 3px solid white;
  border-radius: 50%;

  &--online {
    background-color: var(--colour-third);
  }
}

.svg-icon {
  width: 70%;

  & path,
  circle {
    fill: var(--colour-primary);
  }

  &--send {
    width: 60%;

    & path,
    circle {
      fill: white;
    }
  }
  &--search {
    width: 40%;

    & path,
    circle {
      fill: var(--bg-page-darkest);
    }
  }
  &--send-img {
    width: 55%;

    & path,
    circle {
      fill: var(--bg-page-darkest);
    }
  }
  &--send-emoji {
    width: 60%;

    & path,
    circle {
      fill: var(--bg-page-darkest);
    }
  }
  &--previous {
    width: 55%;
  }
  &--dark-mode {
    width: 80%;

    & path,
    circle {
      fill: var(--colour-primary);
    }
  }
}

.chat-header {
  padding: 3px 10px;
}

.chat-header .custom-control {
  padding-left: 0px;
}
.chat-header .form-group {
  margin-bottom: 0px;
}

.translated-text {
  border-top: 1px solid white;
}

.switch-button-box-chat {
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
